import { isNullOrUndefined } from 'util';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { delay } from 'q';
import * as d3 from 'd3';
import { ActivatedRoute, Params, Router } from '@angular/router';
// import { RadarService } from '../../side-bar/nowcast-dashboard/radar/radar.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { NowcastDataServiceService } from '../../side-bar/nowcast-dashboard/nowcast-data-service.service';
import { HeatIndexDataService } from '../../side-bar/heat-index/heat-index-data.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-play-progress-bar',
  templateUrl: './play-progress-bar.component.html',
  styleUrls: ['./play-progress-bar.component.scss']
})
export class PlayProgressBarComponent implements OnInit, OnDestroy, OnChanges {

  styleObjforBottomBar: {};
  playpause: boolean;
  state = 'stop';
  playWidth: any = 3;
  startIndex: any = 0;
  bottomBarMenuSelectedIndex = 0;
  oldPlayButton: any;
  playBetweenIndex: any;
  forecastLengthSubscription: any;
  forecastLength: any;
  currentIndex: any = 0;
  urlparams: any;
  routeSections: string[] = [];
  application: string;
  // radarSource : string;
  selectedSource: string;
  subApplication: string;
  queryParams: any;
  destroy: Subject<boolean> = new Subject<boolean>();
  isDestroyed: boolean;
  // updateVisibility: any;

  constructor(private route: ActivatedRoute, private router: Router, private utils: UtilsService, private heatIndexService: HeatIndexDataService) {
    this.forecastLengthSubscription = this.route.params.subscribe(routeParams => {
      const forecastLength = routeParams.time;
      if (forecastLength != this.forecastLength) {
        this.forecastLength = routeParams.time;
        this.bottomBarMenuSelectedIndex = 0;
        this.styleObjforBottomBar = { width: 0 };
      }
    });
    this.styleObjforBottomBar = { width: 0 };
  }

  @Input() playButtonDisable: boolean;
  @Input() labelStrings: any;
  @Input() playPosition: number;
  @Input() activeSideMenu: any;
  @Input() playFastSlow: boolean;
  @Input() playbarParams: any;
  @Input() activeGroupName: any;
  @Output() groupSelected = new EventEmitter<any>();
  @Output() animationPageEnd = new EventEmitter<void>();
  @Output() playStarted = new EventEmitter<void>();
  ngOnInit() {
    this.application = this.router.url.split('/')[1];
    this.subApplication = this.router.url.split('/')[2]
    // this.radarSourceService.radarSource.subscribe(data => {
    //   this.radarSource = data;
    // });
    // this.utils.getRadarSourceData().subscribe((source) => {
    //   this.selectedSource = source;
    //   if(this.application == 'nowcastweather' && this.selectedSource != 'RICKEN'){
    //     this.bottomBarMenuSelectedIndex = 5;
    //     this.startIndex = 5;
    //     this.currentIndex = 5;
    //     this.playBetweenIndex = 5;
    //   } else {
    //     this.bottomBarMenuSelectedIndex = 0;
    //     this.startIndex = 0;
    //     this.currentIndex = 0;
    //     this.playBetweenIndex = 0;
    //   }
    // this.updateVisibility();
    // console.log('isObservedWeather:', this.isObservedWeather);
    //       console.log('shouldDisplayObservedRainfall:', this.shouldDisplayObservedRainfall());
    //       console.log('shouldDisplayForecastRainfall:', this.shouldDisplayForecastRainfall());
    // });
    // this.utils.getNowcastView().subscribe(view => {
    //   if(this.application == "nowcastweather" && view && this.selectedSource != 'RICKEN') {
    //     this.bottomBarMenuSelectedIndex = 5;
    //     this.startIndex = 5;
    //     this.currentIndex = 5;
    //     this.playBetweenIndex = 5;
    //   } else {
    //     this.bottomBarMenuSelectedIndex = 0;
    //     this.startIndex = 0;
    //     this.currentIndex = 0;
    //     this.playBetweenIndex = 0;
    //   }
    // });
    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      this.queryParams = {};
      // for (const param in params) {
      //   if (params.hasOwnProperty(param)) {
      //     this.queryParams = params[param];
      //   }
      // }
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.selectedSource = this.queryParams['source'];
      }
    })
  }
  ngOnDestroy() {
    this.forecastLengthSubscription.unsubscribe();
    this.isDestroyed = true;      
    this.state = 'stop';          
    localStorage.removeItem('playBarIndex');
    this.utils.setActiveIndex(null);   
  }



  ngOnChanges(change: SimpleChanges) {
    // activeGroupName (gisMapComp.activeGroup) is mutated by every feature's changeTimeLayers
    // on EVERY playback tick, which re-fires ngOnChanges on this same component while animate()
    // is mid-loop. If only that echo changed, skip the reset below entirely — otherwise it
    // clobbers this.state back to 'stop' and animate()'s loop guard (state === 'play'/'resume')
    // exits after exactly one tick.
    const isAnimating = this.state === 'play' || this.state === 'resume';
    const onlyActiveGroupEchoed = isAnimating && change.activeGroupName
      && !change.playButtonDisable && !change.labelStrings && !change.playPosition
      && !change.playbarParams && !change.activeSideMenu && !change.playFastSlow;
    if (onlyActiveGroupEchoed) {
      return;
    }
    if (!isNullOrUndefined(change.playPosition) && !isNullOrUndefined(change.playPosition.currentValue)) {
      setTimeout(() => this.changeStartIndex(change.playPosition.currentValue), 10);
    }
    if (((this.router.url.split('/')[2] === 'cloudcover' || this.router.url.split('/')[2] === 'cloudtemperature'))
      || (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
      setTimeout(() => {
        if (this.state !== 'play' && this.state !== 'resume') {
          this.changeStartIndex(this.labelStrings.length - 1);
        }
      }, 100);
    }
    this.urlparams = this.getCurrentUrlParams();

    // if (!isNullOrUndefined(change.playButtonDisable) && this.playButtonDisable == true) {
    this.oldPlayButton = this.playButtonDisable;
    this.styleObjforBottomBar = { width: 0 };
    this.state = 'stop';
    this.playWidth = 3;
    let selectedIndex = localStorage.getItem('playBarIndex')
    let index: any;
    // Rainfall Forecast -7D's selected day is decided by RainfallForecastMapService — it
    // defaults to "today" on a fresh entry into -7D and preserves whatever day the user last
    // picked across administrative drilldowns (see rainfall-forecast-map.service.ts:
    // last7DSelectedGroupName, createlast7HeatMapLayers(), changeTimeLayers()). That decision is
    // surfaced here purely via gisMapComp.activeGroup (activeGroupName) matched against the
    // current labelStrings — not via the shared, cross-module localStorage['playBarIndex']
    // value, which could be stale from a different time menu/component. Falls back to "last day"
    // if no match is found (e.g. labelStrings not yet populated), matching the previous default.
    // A manual date click still works exactly as before: it updates playBarIndex and
    // playPosition, and the changeStartIndex() scheduled above (10ms) applies it after this.
    const isRainfallLast7Days = this.subApplication == 'rainfall-forecast'
      && this.playbarParams && this.playbarParams['forecastLength'] === '-7D';
    const activeGroupIndex = (isRainfallLast7Days && this.labelStrings && !isNullOrUndefined(this.activeGroupName))
      ? this.labelStrings.findIndex(l => l && l['groupName'] === this.activeGroupName)
      : -1;
    if (activeGroupIndex > -1) {
      index = activeGroupIndex;
    } else if (isRainfallLast7Days && this.labelStrings && this.labelStrings.length > 0) {
      index = this.labelStrings.length - 1;
    } else if (!isNullOrUndefined(selectedIndex)) {
      index = Number(selectedIndex)
    } else {
      index = this.subApplication == 'heatwave' ? this.heatIndexService.setBlockNumber() : 0;
    }
    // A previously stored index (e.g. from a longer hourly block list) can be
    // out of range once labelStrings switches to a shorter list (e.g. daily
    // blocks) — clamp it so the play bar doesn't end up pointing at an
    // undefined entry (broken progress width / no active highlight).
    if (this.labelStrings && this.labelStrings.length > 0 && !isNullOrUndefined(index)) {
      index = Math.max(0, Math.min(index, this.labelStrings.length - 1));
    }
    // if (this.subApplication == 'heatwave') {
    //   this.bottomBarMenuSelectedIndex = index;
    //   this.startIndex = index;
    //   this.currentIndex = index;
    //   this.playBetweenIndex = index;
    // } 
    if ((this.subApplication == 'nowcast' || this.subApplication == 'kolkata-nowcast' || (this.subApplication == 'abg-site' && this.queryParams['dashboardName'] == 'nowcast')) && this.selectedSource != 'RICKEN') {
      this.bottomBarMenuSelectedIndex = !isNullOrUndefined(selectedIndex) ? Number(selectedIndex) : this.selectedSource != 'EUMETSAT' ? 5 : 7;
      this.startIndex = !isNullOrUndefined(selectedIndex) ? Number(selectedIndex) : this.selectedSource != 'EUMETSAT' ? 5 : 7;
      this.currentIndex = !isNullOrUndefined(selectedIndex) ? Number(selectedIndex) : this.selectedSource != 'EUMETSAT' ? 5 : 7;
      this.playBetweenIndex = !isNullOrUndefined(selectedIndex) ? Number(selectedIndex) : this.selectedSource != 'EUMETSAT' ? 5 : 7;
    } else {
      this.bottomBarMenuSelectedIndex = index;
      this.startIndex = index;
      this.currentIndex = index;
      this.playBetweenIndex = index;
    }
    this.changebutton();
    if (this.labelStrings && this.labelStrings[this.startIndex]) {
      this.groupSelected.emit(this.labelStrings[this.startIndex]['groupName']);
    }
    // }
    if (this.labelStrings.length > 0) {
      const i = this.bottomBarMenuSelectedIndex;
      // const width = ((i) * (100 / (this.labelStrings.length - 1)));
      const width = ((i + 1) / this.labelStrings.length * 100);
      if ((this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
        this.styleObjforBottomBar = {};
      } else {
        this.styleObjforBottomBar = { width: width.toString() + '%' };
      }
    }
  }
  get showWeatherLabel(): boolean {
    return this.labelStrings.length > 0;
  }

  get hideStandalonePlayButton(): boolean {
    const params = this.playbarParams || this.queryParams || {};
    return (this.subApplication === 'rainfall-forecast')
      && ((params['source'] === 'ECMWF'
      && params['forecastLength'] === 'seasonal') || params['forecastLength'] === 'YTD');
  }

  get isSeasonalRainfallPlaybar(): boolean {
    const params = this.playbarParams || this.queryParams || {};
    return this.subApplication === 'rainfall-forecast'
      && params['forecastLength'] === 'seasonal';
  }

  get isObservedWeather(): boolean {
    return this.selectedSource == 'EUMETSAT' ? this.bottomBarMenuSelectedIndex < 8 : this.bottomBarMenuSelectedIndex < 6;
  }
  shouldDisplayObservedRainfall(): boolean {
    const result = this.isObservedWeather && this.selectedSource !== 'RICKEN';
    // console.log('shouldDisplayObservedRainfall:', result);
    return result;
  }

  shouldDisplayForecastRainfall(): boolean {
    const result = !this.isObservedWeather && (
      this.selectedSource === 'RADAR' ||
      this.selectedSource === 'IMD RADAR' ||
      this.selectedSource === 'RADAR+CTT' ||
      this.selectedSource === 'IMD_LONG_RANGE' ||
      this.selectedSource === 'EUMETSAT'
    );
    // console.log('shouldDisplayForecastRainfall:', result);
    return result;
  }

  reverseThreeDays() {
    if (this.state === 'pause') {
      this.state = 'play';
      this.animateProgressBar();
    } else {
      this.state = 'pause';
    }
    this.changeReverseButton();
    d3.select('#button_play i').attr('class', 'fa fa-play')
  }

  async animateProgressBar() {
    let newIndex = this.startIndex - 1;
    if (newIndex < 0) {
      newIndex = 0;
    }
    const animateStep = async () => {
      this.startIndex = newIndex;
      this.currentIndex = newIndex;
      // const width = ((newIndex) * (100 / (this.labelStrings.length - 1)));
      const width = ((newIndex + 1) / this.labelStrings.length * 100);
      this.styleObjforBottomBar = { width: width.toString() + '%' };
      this.bottomBarMenuSelectedIndex = newIndex
      if (this.labelStrings && this.labelStrings[newIndex]) {
        this.groupSelected.emit(this.labelStrings[newIndex]['groupName']);
      }
      await delay(1000);
      if (newIndex > 0 && this.state === 'play') {
        newIndex--;
        await animateStep();
      } else if (newIndex === 0 && this.state === 'play') {
        let index: any = this.labelStrings.length - 1//this.heatIndexService.setBlockNumber();
        newIndex = index;
        await animateStep();
      }
    };
    if (this.state === 'play') {
      animateStep();
    }
  }

  async animate() {
    // console.log("hello");
    this.changebutton();
    this.playpause = !this.playpause;
    /*This if written for the condition when width is 100 and user clicks play button*/
    if (this.state == 'play' || this.state == 'resume') {
      this.state = 'pause';
      this.changebutton();
      return;
    }

    if (this.state == 'stop') {
      this.playStarted.emit();
      await delay(0);
      this.startIndex = 0;
      const width = 3;
      this.playWidth = 12 / (this.labelStrings.length - 1);
      if ((this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
        this.styleObjforBottomBar = {};
      } else {
        this.styleObjforBottomBar = { width: width.toString() };
      }
      if (this.labelStrings && this.labelStrings[0]) {
        this.groupSelected.emit(this.labelStrings[0]['groupName']);
      }
      this.bottomBarMenuSelectedIndex = 3;
      this.state = 'play';
      this.changebutton();
    } else if (this.state == 'pause') {
      this.state = 'play';
      this.changebutton();
    }
    // console.log(this.mapDataForAllTs.length);
    for (let index = this.startIndex; index <= this.labelStrings.length; index++) {
      if (this.isDestroyed) { return; }
      this.currentIndex = index;
      if ((this.state === 'play' || this.state === 'resume')) {
        // let width = this.playWidth;
        if (index >= this.labelStrings.length) {
          this.animationPageEnd.emit();
          this.startIndex = 3;
          this.currentIndex = 3;
          this.bottomBarMenuSelectedIndex = 0;
          index = -1;
          this.playWidth = 3;
          this.playBetweenIndex = 3;
          const width = 3;
          if ((this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
            this.styleObjforBottomBar = {};
          } else {
            this.styleObjforBottomBar = { width: width.toString() + '%' };
          }
          await delay(1000);
          continue;
        }
        if (this.labelStrings && this.labelStrings[index]) {
          this.groupSelected.emit(this.labelStrings[index]['groupName']);
        }
        this.bottomBarMenuSelectedIndex = index;
        this.utils.setActiveIndex(index)
        let i = this.playBetweenIndex;
        localStorage.setItem("playBarIndex", index)
        while (i <= 30) {
          if (this.state === 'play' || this.state === 'resume') {
            const width = ((index) * (100 / (this.labelStrings.length - 1))) + (i * ((100 / (this.labelStrings.length - 1)) / 30)) + (2.5 - ((this.labelStrings.length - 5) / 12));
            const num = 6;
            if ((this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
              this.styleObjforBottomBar = {};
            } else {
              this.styleObjforBottomBar = { width: width.toString() + '%', transition: num.toString() + 's' + 'ease' };
            }
            if ((
              (this.router.url.split('/')[2] === 'cloudcover' ||
                this.router.url.split('/')[2] === 'cloudtemperature')) || (this.router.url.split('/')[1] === 'nowcastweather' && this.playFastSlow == true)) {
              await delay(5);
            } else {
              await delay(50);
            }
          } else {
            this.startIndex = index;
            this.currentIndex = index;
            this.playBetweenIndex = i;
            return;
          }
          i++;
          if (index != this.currentIndex) {
            i = -10;
            index = this.currentIndex;
          }
        }
        this.playBetweenIndex = 3;
        if (index === this.labelStrings.length) {
          this.animationPageEnd.emit();
          this.startIndex = 3;
          this.currentIndex = 3;
          this.bottomBarMenuSelectedIndex = 0;
          index = -1;
          this.playWidth = 3;
          this.playBetweenIndex = 3;
          const width = 3;
          if (
            (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
            this.styleObjforBottomBar = {};
          } else {
            this.styleObjforBottomBar = { width: width.toString() + '%' };
          }
          await delay(1000);
          continue;
          // this.changebutton();
        }
        await delay(100);
      } else {
        if (index < this.labelStrings.length) {
          this.startIndex = index;
          this.currentIndex = index;
          this.state = 'pause';
        } else {
          this.startIndex = 1;
          this.currentIndex = 1;
          this.state = 'pause';
        }
        break;
      }
    }

  }

  changeStartIndex(i) {
    if (i == this.currentIndex) {
      return;
    }
    this.startIndex = i;
    this.currentIndex = i;
    this.bottomBarMenuSelectedIndex = i;
    this.playBetweenIndex = i;
    this.utils.setActiveIndex(i);
    // const width = ((i) * (100 / (this.labelStrings.length - 1)));
    const width = ((i + 1) / this.labelStrings.length * 100);
    if (
      (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
      this.styleObjforBottomBar = {};
    } else {
      this.styleObjforBottomBar = { width: width.toString() + '%' };
    }
    if (this.labelStrings && this.labelStrings[i]) {
      this.groupSelected.emit(this.labelStrings[i]['groupName']);
    }
  }

  setValue(index) {
    localStorage.setItem("playBarIndex", index)
  }

  changebutton() {
    if (this.state == 'play' || this.state == 'resume') {
      d3.select('#button_play i').attr('class', 'fa fa-pause');
      d3.select('#button_play_reverse i').attr('class', 'fa fa-play icon-rotate-left');
    } else {
      d3.select('#button_play i').attr('class', 'fa fa-play');
    }

  }

  changeReverseButton() {
    if (this.state == 'play' || this.state == 'resume') {
      d3.select('#button_play_reverse i').attr('class', 'fa fa-pause');
    } else {
      d3.select('#button_play_reverse i').attr('class', 'fa fa-play icon-rotate-left');
    }

  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['label'];
    }
  }
  formatDateLabel(label: string): string {
  if (!label) {
    return '';
  }

  const parts = label.trim().split(' ');

      const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];

  if (parts.length === 2) {
    const day = parts[0].padStart(2, '0');
    const monthName = parts[1];

    const monthIndex = months.findIndex(
      month => month.toLowerCase() === monthName.toLowerCase()
    );

    if (monthIndex !== -1) {
      const month = (monthIndex + 1).toString().padStart(2, '0');
      const year = new Date().getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
    if (parts.length === 3) {
    const day = parts[0].padStart(2, '0');
    const monthName = parts[1];
    const year = parts[2];

    const monthIndex = months.findIndex(
      month => month.toLowerCase() === monthName.toLowerCase()
    );

    if (monthIndex !== -1) {
      const month = (monthIndex + 1).toString().padStart(2, '0');
      return `${day}/${month}/${year}`;
    }
  }
    

  return label;
}
  getToolTipValue(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['toolTip'];
    }
  }

  getCurrentUrlParams() {
    const obj = this.route.snapshot.params;
    this.routeSections = this.router.url.split('/');
    if (obj == null || obj == undefined) { return obj; }
    if (this.routeSections[1] === 'extremeweather' && this.routeSections[2] === 'rainfall' &&
      this.routeSections[3] === '24') {
      if (this.labelStrings && this.labelStrings.length > 0) {
        const i = this.labelStrings.length - 1;
        this.startIndex = i;
        this.currentIndex = i;
        this.bottomBarMenuSelectedIndex = i;
        this.playBetweenIndex = 3;
        this.groupSelected.emit(this.labelStrings[i]['groupName']);
      }
    }
    const objectConfig = {};
    for (const key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }

  // showtooltipval() {
  //   if (this.urlparams['time'] || ( this.routeSections[1] === 'cyclone')) {
  //     return true;
  //   }
  //   return false;
  // }

  showtooltipval() {
    if (this.queryParams['forecastLength'] || (this.routeSections[1] === 'cyclone')) {
      return true;
    }
    return false;
  }

  // changebutton() {
  //   console.log(this.state);
  //   if (this.state === 'stop') {
  //     this.state = 'play';
  //     let button = d3.select('#button_play').classed('btn-success', true);
  //     button.select('i').attr('class', 'fa fa-play');
  //   } else if (this.state == 'play' || this.state == 'resume') {
  //     this.state = 'pause';
  //     d3.select('#button_play i').attr('class', 'fa fa-play');
  //   } else if (this.state == 'pause') {
  //     this.state = 'resume';
  //     d3.select('#button_play i').attr('class', 'fa fa-pause');
  //   } else if(this.state === 'end'){
  //     this.state = 'stop';
  //     d3.select('#button_play i').attr('class', 'fa fa-play');
  //   }

  //   console.log(this.state);
  // }
  hasObserved(): boolean {
    return this.labelStrings.some(l => l.type === 'Observed');
  }

  hasForecast(): boolean {
    return this.labelStrings.some(l => l.type === 'Forecast');
  }

  getClasses(item: any, i: number) {
    let classes: any = {};

    if (item.type) {
      classes[item.type] = true; // dynamic class
    }

    classes['active'] = this.bottomBarMenuSelectedIndex === i;
    classes['before-active'] = i < this.bottomBarMenuSelectedIndex;
    classes['after-active'] = i > this.bottomBarMenuSelectedIndex;

    return classes;
  }

  onWheelScroll(event: WheelEvent) {
    const container = event.currentTarget as HTMLElement;

    if (event.deltaY !== 0) {
      event.preventDefault();
      container.scrollLeft += event.deltaY;
    }
  }


}
